import { FC } from 'react';
import { CustomersRow, PaginatedList, TitlePage } from '~/components';
import { customersColumns } from '~/utils';
import { ContentBox, TopBox, Wrapper } from './styles';

type Props = {
  isCustomersLoading: boolean;
  customersList: ListResponse<Customer>;
  onChangePage(page: number): void;
  onPressCustomer(customer: Customer): void;
};

const Customers: FC<Props> = ({
  customersList,
  isCustomersLoading,
  onChangePage,
  onPressCustomer,
}) => (
  <Wrapper titlePage="Customers">
    <ContentBox>
      <TopBox>
        <TitlePage totalElements={customersList.paging?.totalElements}>
          Customers
        </TitlePage>
      </TopBox>

      <PaginatedList
        columns={customersColumns}
        list={customersList.content}
        totalPages={customersList.paging?.totalPages}
        currentPage={customersList.paging?.page}
        isLoading={isCustomersLoading}
        onChangePage={onChangePage}
        renderList={(customer) => (
          <CustomersRow
            name={customer?.name}
            refDocument={customer?.refDocument}
            type={customer?.type}
            onPress={() => onPressCustomer(customer)}
            key={customer?.id}
          />
        )}
        titleEmptyData="Sem customers disponíveis"
      />
    </ContentBox>
  </Wrapper>
);

export default Customers;
